<mat-dialog-content
  style="
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  "
>
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-card class="container">
    <form [formGroup]="skuForm">
      <div
        style="
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          gap: 16px;
        "
      >
        <mat-form-field appearance="outline">
          <mat-label>Nombre</mat-label>
          <input
            matInput
            placeholder="Nombre"
            formControlName="nombreInsumo"
            name="nombre"
            required
          />
        </mat-form-field>

        <div
          *ngIf="coincidencias.length > 0"
          style="
            padding: 2rem;
            border-color: #ffa101;
            border-radius: 10px;
            border-style: solid;
            border-width: 3px;
          "
        >
          <div style="display: flex; gap: 0.5rem">
            <mat-icon style="color: #ffa101">warning</mat-icon>
            <h3 *ngIf="coincidencias.length === 1" style="color: #ffa101">
              Existe {{ coincidencias.length }} SKU similar:
            </h3>
            <h3 *ngIf="coincidencias.length > 1" style="color: #ffa101">
              Existen {{ coincidencias.length }} SKUs similares:
            </h3>
          </div>

          <ul *ngFor="let item of coincidencias">
            <li>{{ item.nombreInsumo }}</li>
          </ul>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Categoría</mat-label>
          <mat-select formControlName="categoria">
            <mat-option
              *ngFor="let categoria of arrayCategoria"
              value="{{ categoria }}"
              >{{ categoria }}</mat-option
            >
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Unidad de Medida</mat-label>
          <mat-select formControlName="unidadMedida" required>
            <mat-option
              *ngFor="let unidadMedida of arrayUM"
              value="{{ unidadMedida }}"
              >{{ unidadMedida }}</mat-option
            >
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Peso</mat-label>
          <input
            matInput
            placeholder="Peso"
            formControlName="peso"
            name="peso"
            type="number"
            min="0"
            required
          />
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="this.data.estado === 1">
          <mat-label>Stock Real &#40;Ingreso - Egreso&#41;</mat-label>
          <input
            matInput
            placeholder="Ingreso - Egreso"
            formControlName="stock"
            name="stock"
            type="number"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="this.data.estado === 1">
          <mat-label>Stock Teórico</mat-label>
          <input
            matInput
            placeholder="Stock Teórico"
            formControlName="stockTeorico"
            name="stockTeorico"
            type="number"
            required
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Estado</mat-label>
          <mat-select formControlName="estado" required>
            <mat-option
              *ngFor="let estado of arrayEstados"
              value="{{ estado }}"
              >{{ estado }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </mat-card>
  <mat-dialog-actions
    style="display: flex; align-items: center; justify-content: space-around"
  >
    <button mat-button mat-dialog-close>Cancelar</button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="this.data.estado == 1"
      (click)="updateFoodItem()"
    >
      {{ data.title }}
    </button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="this.data.estado == 2"
      (click)="createFoodItemSku()"
    >
      {{ data.title }}
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
